// //client/src/pages/HomePage.jsx
// import React from "react";
// import { useNavigate } from "react-router-dom";

// export default function HomePage({
//   onInvoice,
//   onPayment,
//   onDashboard,
// }) {
//   return (
//     <div className="page-wrap">
//       <header className="topbar">
//         <div className="brand">
//           <span className="logo">📄</span>

//           <div>
//             <div className="title">
//               SISL Portal
//             </div>

//             <div className="subtitle">
//               Invoice & Payment Management
//             </div>
//           </div>
//         </div>
//       </header>

//       <main className="center">
//         <div className="card">

//           <h1>
//             Welcome to SISL Portal
//           </h1>

//           <p className="desc">
//             Select a module to continue
//           </p>

//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "15px",
//               marginTop: "30px",
//             }}
//           >

//             <button
//               className="primary-btn"
//               onClick={onInvoice}
//             >
//               Invoice Processing
//             </button>

//             <button
//               className="primary-btn"
//               onClick={onPayment}
//             >
//               Payment Management
//             </button>

//             <button
//               className="primary-btn"
//               onClick={onDashboard}
//             >
//               Reports & Dashboard
//             </button>

//           </div>
//         </div>
//       </main>
//     </div>
//   );
// }

// //client/src/pages/HomePage.jsx
// import React from "react";
// import { useNavigate } from "react-router-dom";

// export default function HomePage() {

//   const navigate = useNavigate();

//   return (
//     <div className="page-wrap">

//       <header className="topbar">
//         <div className="brand">

//           <span className="logo">📄</span>

//           <div>
//             <div className="title">
//               SISL Portal
//             </div>

//             <div className="subtitle">
//               Invoice & Payment Management
//             </div>
//           </div>

//         </div>
//       </header>

//       <main className="center">

//         <div className="card">

//           <h1>
//             Welcome to SISL Portal
//           </h1>

//           <p className="desc">
//             Select a module to continue
//           </p>

//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "15px",
//               marginTop: "30px",
//             }}
//           >

//             <button
//               className="primary-btn"
//               onClick={() => navigate("/invoice")}
//             >
//               Invoice Processing
//             </button>

//             <button
//               className="primary-btn"
//               onClick={() => navigate("/payment")}
//             >
//               Payment Management
//             </button>

//             <button
//               className="primary-btn"
//               onClick={() => navigate("/dashboard")}
//             >
//               Reports & Dashboard
//             </button>

//           </div>

//         </div>

//       </main>

//     </div>
//   );
// }



// import React from "react";
// import { useNavigate } from "react-router-dom";
// import "./HomePage.css";

// export default function HomePage() {

//   const navigate = useNavigate();

//   const workspaces = [

//     {
//       icon: "📄",
//       title: "Invoice Processing",
//       description:
//         "Upload and process vendor PDF invoices, extract data and export reconciliation sheets.",
//       route: "/invoice",
//     },

//     {
//       icon: "💰",
//       title: "Payment Reconciliation",
//       description:
//         "Upload payment Excel sheets and automatically match them against vendor invoices.",
//       route: "/payment",
//     },

//     {
//       icon: "📊",
//       title: "Reports & Dashboard",
//       description:
//         "Monitor invoices, payments, vendors and reconciliation performance.",
//       route: "/dashboard",
//     },
//   ];

//   return (

//     <div className="home-page">

//       {/* HEADER */}

//       <header className="home-header">

//         <div className="home-brand">

//           <div className="home-logo">
//             📄
//           </div>

//           <div>

//             <div className="home-title">
//               SISL Portal
//             </div>

//             <div className="home-subtitle">
//               Invoice & Payment Management
//             </div>

//           </div>

//         </div>

//         {/* <div className="system-status">
//           <span className="status-dot" />
//           System Online
//         </div> */}

//       </header>

//       {/* SECTION */}

//       <div className="workspace-container">

//         <h2 className="workspace-heading">
//           Available Workspaces
//         </h2>

//         {workspaces.map((item) => (

//           <div
//             key={item.title}
//             className="workspace-card"
//             onClick={() =>
//               navigate(item.route)
//             }
//           >

//             <div className="workspace-left">

//               <div className="workspace-icon">
//                 {item.icon}
//               </div>

//               <div>

//                 <div className="workspace-title">
//                   {item.title}
//                 </div>

//                 <div className="workspace-description">
//                   {item.description}
//                 </div>

//               </div>

//             </div>

//             <div className="workspace-action">
//               Open →
//             </div>

//           </div>
//         ))}

//       </div>

//     </div>
//   );
// }

// //client/src/pages/HomePage.jsx
// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./HomePage.css";

// const workspaces = [
//   {
//     icon: "📄",
//     title: "Invoice Processing",
//     description:
//       "Upload and process vendor PDF invoices, extract data and export reconciliation sheets.",
//     route: "/invoice",
//     tag: "Documents",
//   },
//   {
//     icon: "💰",
//     title: "Payment Management & Edit",
//     description:
//       "Upload payment Excel sheets and automatically match them against vendor invoices.",
//     route: "/payment",
//     tag: "Finance",
//   },
//   {
//     icon: "📊",
//     title: "Reports & Dashboard",
//     description:
//       "Monitor invoices, payments, vendors and reconciliation performance.",
//     route: "/dashboard",
//     tag: "Analytics",
//   },
// ];

// export default function HomePage() {
//   const navigate = useNavigate();
//   const [hidden, setHidden] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const lastY = useRef(0);

//   useEffect(() => {
//     const onScroll = () => {
//       const y = window.scrollY;
//       setScrolled(y > 8);
//       if (y > lastY.current && y > 120) setHidden(true);
//       else setHidden(false);
//       lastY.current = y;
//     };
//     window.addEventListener("scroll", onScroll, { passive: true });
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   return (
//     <div className="home-page">
//       {/* HEADER */}
//       <header
//         className={`home-header ${hidden ? "is-hidden" : ""} ${
//           scrolled ? "is-scrolled" : ""
//         }`}
//       >
//         <div className="home-header-inner">
//           <div className="home-brand">
//             <div className="home-logo">📄</div>
//             <div>
//               <div className="home-title">SISL Portal</div>
//               <div className="home-subtitle">Invoice & Payment Management</div>
//             </div>
//           </div>
//           {/* <div className="system-status">
//             <span className="status-dot" />
//             System Online
//           </div> */}
//         </div>
//       </header>

//       {/* MAIN */}
//       <main className="workspace-container">
//         <div className="workspace-eyebrow">
//   <span className="workspace-eyebrow-dot" />
//   SISL OPERATIONS PLATFORM
// </div>

// <h1 className="workspace-heading">
//   Manage Telecom Financial Workflows
// </h1>

// <p className="workspace-subheading">
//   A centralized workspace for invoice processing, payment management,
//   vendor management, and business reporting.
// </p>

//         <div className="workspace-grid">
//           {workspaces.map((item) => (
//             <button
//               key={item.title}
//               className="workspace-card"
//               onClick={() => navigate(item.route)}
//             >
//               <span className="workspace-rail" />
//               <div className="workspace-left">
//                 <div className="workspace-icon">{item.icon}</div>
//                 <div>
//                   <div className="workspace-title-row">
//                     <h3 className="workspace-title">{item.title}</h3>
//                     <span className="workspace-tag">{item.tag}</span>
//                   </div>
//                   <p className="workspace-description">{item.description}</p>
//                 </div>
//               </div>
//               <div className="workspace-action">
//                 <span className="workspace-action-label">Open</span>
//                 <span className="workspace-action-icon">→</span>
//               </div>
//             </button>
//           ))}
//         </div>
//       </main>
//     </div>
//   );
// }


// // client/src/pages/HomePage.jsx

// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";

// const workspaces = [
//   {
//     icon: "📄",
//     title: "Invoice Processing",
//     description:
//       "Upload vendor PDF invoices, extract structured data and generate reconciliation-ready output sheets.",
//     route: "/invoice",
//     tag: "Documents",
//     tagColor: "#eff6ff",
//     tagText: "#1d4ed8",
//     features: [
//       "PDF data extraction",
//       "Multi-vendor support",
//       "Export to Excel",
//       "Duplicate detection",
//     ],
//     action: "Open Processor",
//     iconBg: "#eff6ff",
//   },
//   {
//     icon: "💰",
//     title: "Payment Management",
//     description:
//       "Upload payment Excel sheets to process and update invoice payment records. Search, filter and edit individual payment entries.",
//     route: "/payment",
//     tag: "Finance",
//     tagColor: "#f5f3ff",
//     tagText: "#7c3aed",
//     features: [
//       "Bulk payment upload",
//       "Auto status update",
//       "Search and filter",
//       "Inline edit",
//     ],
//     action: "Open Payments",
//     iconBg: "#f5f3ff",
//   },
//   {
//     icon: "📊",
//     title: "Reports & Dashboard",
//     description:
//       "Monitor invoices, payments, vendor activity and reconciliation performance across all billing quarters.",
//     route: "/dashboard",
//     tag: "Analytics",
//     tagColor: "#f0fdf4",
//     tagText: "#15803d",
//     features: [
//       "Payment summary",
//       "Vendor breakdown",
//       "Quarter analysis",
//       "Status overview",
//     ],
//     action: "Open Dashboard",
//     iconBg: "#f0fdf4",
//   },
// ];

// export default function HomePage() {

//   const navigate = useNavigate();

//   const [hidden, setHidden] = useState(false);

//   const [scrolled, setScrolled] = useState(false);

//   const lastY = useRef(0);

//   useEffect(() => {

//     const onScroll = () => {

//       const y = window.scrollY;

//       setScrolled(y > 8);

//       if (y > lastY.current && y > 120) setHidden(true);
//       else setHidden(false);

//       lastY.current = y;
//     };

//     window.addEventListener("scroll", onScroll, { passive: true });

//     return () => window.removeEventListener("scroll", onScroll);

//   }, []);

//   return (

//     <div style={styles.page}>

//       {/* HEADER */}

//       <header
//         style={{
//           ...styles.header,
//           ...(scrolled ? styles.headerScrolled : {}),
//           ...(hidden ? styles.headerHidden : {}),
//         }}
//       >

//         <div style={styles.headerInner}>

//           <div style={styles.brand}>

//             <div style={styles.logoWrap}>📄</div>

//             <div>
//               <div style={styles.brandTitle}>SISL Portal</div>
//               <div style={styles.brandSubtitle}>Invoice & Payment Management</div>
//             </div>

//           </div>

//         </div>

//       </header>

//       {/* MAIN */}

//       <main style={styles.main}>

//         {/* HERO */}

//         <div style={styles.hero}>

//           {/* EYEBROW */}

//           <div style={styles.eyebrow}>
//             <span style={styles.eyebrowDot} />
//             <span style={styles.eyebrowText}>SISL OPERATIONS PLATFORM</span>
//           </div>

//           {/* MAIN HEADING */}

//           <h1 style={styles.heading}>
//             Telecom Invoice Extraction
//           </h1>

//           {/* SUB HEADING */}

//           <p style={styles.subheading}>
//             A centralized workspace for automated extraction of telecom vendor invoices,
//             payment processing, reconciliation management and business reporting —
//             built for SISL's financial operations.
//           </p>

//         </div>

//         {/* WORKSPACE CARDS */}

//         <div style={styles.grid}>

//           {workspaces.map((item) => (

//             <div
//               key={item.title}
//               style={styles.card}
//               onClick={() => navigate(item.route)}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.borderColor = "#6366f1";
//                 e.currentTarget.style.boxShadow =
//                   "0 4px 24px rgba(99,102,241,0.10)";
//                 e.currentTarget.style.transform = "translateY(-2px)";
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.borderColor = "#e5e7eb";
//                 e.currentTarget.style.boxShadow = "none";
//                 e.currentTarget.style.transform = "translateY(0)";
//               }}
//             >

//               {/* TOP ROW */}

//               <div style={styles.cardTopRow}>

//                 <div style={{
//                   ...styles.iconWrap,
//                   backgroundColor: item.iconBg,
//                 }}>
//                   <span style={styles.icon}>{item.icon}</span>
//                 </div>

//                 <span style={{
//                   ...styles.badge,
//                   backgroundColor: item.tagColor,
//                   color: item.tagText,
//                 }}>
//                   {item.tag}
//                 </span>

//               </div>

//               {/* TITLE */}

//               <h3 style={styles.cardTitle}>{item.title}</h3>

//               {/* DESC */}

//               <p style={styles.cardDesc}>{item.description}</p>

//               {/* FEATURES */}

//               <div style={styles.featureList}>

//                 {item.features.map((f) => (

//                   <div key={f} style={styles.featureItem}>
//                     <span style={styles.featureDot} />
//                     <span>{f}</span>
//                   </div>
//                 ))}

//               </div>

//               {/* FOOTER */}

//               <div style={styles.cardFooter}>

//                 <div style={styles.footerDivider} />

//                 <div style={styles.cardAction}>

//                   <span style={{
//                     ...styles.actionLabel,
//                     color: item.tagText,
//                   }}>
//                     {item.action}
//                   </span>

//                   <span style={{
//                     ...styles.actionArrow,
//                     color: item.tagText,
//                   }}>
//                     →
//                   </span>

//                 </div>

//               </div>

//             </div>
//           ))}

//         </div>

//       </main>

//     </div>
//   );
// }

// // ─────────────────────────────────────
// // STYLES
// // ─────────────────────────────────────
// const styles = {

//   page: {
//     minHeight: "100vh",
//     backgroundColor: "#f9fafb",
//     fontFamily:
//       "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//   },

//   header: {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     right: 0,
//     height: "56px",
//     backgroundColor: "#0f172a",
//     zIndex: 100,
//     transition: "transform 0.25s ease, box-shadow 0.25s ease",
//     display: "flex",
//     alignItems: "center",
//   },

//   headerScrolled: {
//     boxShadow: "0 1px 0 rgba(255,255,255,0.06)",
//   },

//   headerHidden: {
//     transform: "translateY(-100%)",
//   },

//   headerInner: {
//     width: "100%",
//     maxWidth: "1400px",
//     margin: "0 auto",
//     padding: "0 40px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     boxSizing: "border-box",
//   },

//   brand: {
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//   },

//   logoWrap: {
//     fontSize: "20px",
//     width: "36px",
//     height: "36px",
//     backgroundColor: "rgba(255,255,255,0.08)",
//     borderRadius: "8px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },

//   brandTitle: {
//     fontSize: "14px",
//     fontWeight: "700",
//     color: "#ffffff",
//     letterSpacing: "-0.01em",
//   },

//   brandSubtitle: {
//     fontSize: "11px",
//     color: "rgba(255,255,255,0.45)",
//     fontWeight: "400",
//     marginTop: "1px",
//   },

//   main: {
//     paddingTop: "80px",
//     paddingBottom: "80px",
//     paddingLeft: "40px",
//     paddingRight: "40px",
//     maxWidth: "1400px",
//     margin: "0 auto",
//     boxSizing: "border-box",
//     width: "100%",
//   },

//   hero: {
//     paddingTop: "48px",
//     paddingBottom: "48px",
//     maxWidth: "640px",
//   },

//   eyebrow: {
//     display: "flex",
//     alignItems: "center",
//     gap: "8px",
//     marginBottom: "16px",
//   },

//   eyebrowDot: {
//     width: "6px",
//     height: "6px",
//     borderRadius: "50%",
//     backgroundColor: "#6366f1",
//     display: "inline-block",
//     flexShrink: 0,
//   },

//   eyebrowText: {
//     fontSize: "11px",
//     fontWeight: "700",
//     color: "#6366f1",
//     letterSpacing: "0.08em",
//     textTransform: "uppercase",
//   },

//   heading: {
//     fontSize: "36px",
//     fontWeight: "800",
//     color: "#111827",
//     margin: "0 0 16px 0",
//     letterSpacing: "-0.03em",
//     lineHeight: "1.15",
//   },

//   subheading: {
//     fontSize: "14px",
//     color: "#6b7280",
//     lineHeight: "1.7",
//     margin: 0,
//     fontWeight: "400",
//     maxWidth: "520px",
//   },

//   grid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(3, 1fr)",
//     gap: "20px",
//     width: "100%",
//   },

//   card: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "16px",
//     padding: "24px",
//     backgroundColor: "#ffffff",
//     border: "1px solid #e5e7eb",
//     borderRadius: "10px",
//     cursor: "pointer",
//     transition: "border-color 0.15s, box-shadow 0.15s, transform 0.15s",
//     boxSizing: "border-box",
//   },

//   cardTopRow: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//   },

//   iconWrap: {
//     width: "42px",
//     height: "42px",
//     borderRadius: "10px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     flexShrink: 0,
//   },

//   icon: {
//     fontSize: "18px",
//   },

//   badge: {
//     display: "inline-block",
//     padding: "3px 10px",
//     borderRadius: "4px",
//     fontSize: "11px",
//     fontWeight: "600",
//     letterSpacing: "0.02em",
//   },

//   cardTitle: {
//     fontSize: "15px",
//     fontWeight: "700",
//     color: "#111827",
//     margin: 0,
//     letterSpacing: "-0.01em",
//   },

//   cardDesc: {
//     fontSize: "13px",
//     color: "#6b7280",
//     lineHeight: "1.65",
//     margin: 0,
//     fontWeight: "400",
//   },

//   featureList: {
//     display: "grid",
//     gridTemplateColumns: "1fr 1fr",
//     gap: "7px 12px",
//   },

//   featureItem: {
//     display: "flex",
//     alignItems: "center",
//     gap: "6px",
//     fontSize: "12px",
//     color: "#9ca3af",
//     fontWeight: "500",
//   },

//   featureDot: {
//     width: "4px",
//     height: "4px",
//     borderRadius: "50%",
//     backgroundColor: "#d1d5db",
//     flexShrink: 0,
//   },

//   cardFooter: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "14px",
//     marginTop: "auto",
//   },

//   footerDivider: {
//     height: "1px",
//     backgroundColor: "#f3f4f6",
//   },

//   cardAction: {
//     display: "flex",
//     alignItems: "center",
//     gap: "5px",
//   },

//   actionLabel: {
//     fontSize: "12px",
//     fontWeight: "700",
//   },

//   actionArrow: {
//     fontSize: "14px",
//   },

// };


// client/src/pages/HomePage.jsx

import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const workspaces = [
  {
    icon: "📄",
    title: "Invoice Processing",
    description:
      "Upload vendor PDF invoices, extract structured data and generate reconciliation-ready output sheets.",
    route: "/invoice",
    tag: "Documents",
    tagColor: "#eff6ff",
    tagText: "#1d4ed8",
    features: [
      "PDF data extraction",
      "Multi-vendor support",
      "Export to Excel",
      "Duplicate detection",
    ],
    action: "Open Processor",
    iconBg: "#eff6ff",
  },
  {
    icon: "💰",
    title: "Payment Management",
    description:
      "Upload payment Excel sheets to process and update invoice payment records. Search, filter and edit individual payment entries.",
    route: "/payment",
    tag: "Finance",
    tagColor: "#f5f3ff",
    tagText: "#7c3aed",
    features: [
      "Bulk payment upload",
      "Auto status update",
      "Search and filter",
      "Inline edit",
    ],
    action: "Open Payments",
    iconBg: "#f5f3ff",
  },
  {
    icon: "📊",
    title: "Reports & Dashboard",
    description:
      "Monitor invoices, payments, vendor activity and reconciliation performance across all billing quarters.",
    route: "/dashboard",
    tag: "Analytics",
    tagColor: "#f0fdf4",
    tagText: "#15803d",
    features: [
      "Payment summary",
      "Vendor breakdown",
      "Quarter analysis",
      "Status overview",
    ],
    action: "Open Dashboard",
    iconBg: "#f0fdf4",
  },
];

export default function HomePage() {

  const navigate = useNavigate();

  const [hidden, setHidden] = useState(false);

  const [scrolled, setScrolled] = useState(false);

  const lastY = useRef(0);

  useEffect(() => {

    const onScroll = () => {

      const y = window.scrollY;

      setScrolled(y > 8);

      if (y > lastY.current && y > 120) setHidden(true);
      else setHidden(false);

      lastY.current = y;
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    return () => window.removeEventListener("scroll", onScroll);

  }, []);

  return (

    <div style={styles.page}>

      {/* HEADER */}

      <header
        style={{
          ...styles.header,
          ...(scrolled ? styles.headerScrolled : {}),
          ...(hidden ? styles.headerHidden : {}),
        }}
      >

        <div style={styles.headerInner}>

          <div style={styles.brand}>

            <div style={styles.logoWrap}>📄</div>

            <div>
              <div style={styles.brandTitle}>PSBS Portal</div>
              <div style={styles.brandSubtitle}>Invoice & Payment Management</div>
            </div>

          </div>

        </div>

      </header>

      {/* MAIN */}

      <main style={styles.main}>

        {/* HERO */}

        <div style={styles.hero}>

          <div style={styles.eyebrow}>
            <span style={styles.eyebrowDot} />
            <span style={styles.eyebrowText}>PSBS OPERATIONS PLATFORM</span>
          </div>

          <h1 style={styles.heading}>
            Telecom Invoice Extraction
          </h1>

          <p style={styles.subheading}>
            A centralized workspace for automated extraction of telecom vendor
            invoices, payment processing, reconciliation management and business
            reporting — built for PSBS's financial operations.
          </p>

        </div>

        {/* GRID */}

        <div style={styles.grid}>

          {workspaces.map((item) => (

            <div
              key={item.title}
              style={styles.card}
              onClick={() => navigate(item.route)}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "#6366f1";
                e.currentTarget.style.boxShadow =
                  "0 4px 24px rgba(99,102,241,0.10)";
                e.currentTarget.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "#e5e7eb";
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >

              {/* TOP ROW */}

              <div style={styles.cardTopRow}>

                <div style={{
                  ...styles.iconWrap,
                  backgroundColor: item.iconBg,
                }}>
                  <span style={styles.icon}>{item.icon}</span>
                </div>

                <span style={{
                  ...styles.badge,
                  backgroundColor: item.tagColor,
                  color: item.tagText,
                }}>
                  {item.tag}
                </span>

              </div>

              {/* TITLE */}

              <div style={styles.cardMiddle}>

                <h3 style={styles.cardTitle}>{item.title}</h3>

                <p style={styles.cardDesc}>{item.description}</p>

              </div>

              {/* FEATURES */}

              <div style={styles.featureList}>

                {item.features.map((f) => (

                  <div key={f} style={styles.featureItem}>
                    <span style={styles.featureDot} />
                    <span>{f}</span>
                  </div>

                ))}

              </div>

              {/* FOOTER */}

              <div style={styles.cardFooter}>

                <div style={styles.footerDivider} />

                <div style={styles.cardAction}>

                  <span style={{
                    ...styles.actionLabel,
                    color: item.tagText,
                  }}>
                    {item.action}
                  </span>

                  <span style={{
                    ...styles.actionArrow,
                    color: item.tagText,
                  }}>
                    →
                  </span>

                </div>

              </div>

            </div>

          ))}

        </div>

      </main>

    </div>
  );
}

// ─────────────────────────────────────
// STYLES
// ─────────────────────────────────────
const styles = {

  page: {
    minHeight: "100vh",
    backgroundColor: "#f9fafb",
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },

  header: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: "56px",
    backgroundColor: "#0f172a",
    zIndex: 100,
    transition: "transform 0.25s ease, box-shadow 0.25s ease",
    display: "flex",
    alignItems: "center",
  },

  headerScrolled: {
    boxShadow: "0 1px 0 rgba(255,255,255,0.06)",
  },

  headerHidden: {
    transform: "translateY(-100%)",
  },

  headerInner: {
    width: "100%",
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "0 40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
  },

  brand: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },

  logoWrap: {
    fontSize: "20px",
    width: "36px",
    height: "36px",
    backgroundColor: "rgba(255,255,255,0.08)",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  brandTitle: {
    fontSize: "14px",
    fontWeight: "700",
    color: "#ffffff",
    letterSpacing: "-0.01em",
  },

  brandSubtitle: {
    fontSize: "11px",
    color: "rgba(255,255,255,0.45)",
    fontWeight: "400",
    marginTop: "1px",
  },

  main: {
    paddingTop: "80px",
    paddingBottom: "80px",
    paddingLeft: "40px",
    paddingRight: "40px",
    maxWidth: "1400px",
    margin: "0 auto",
    boxSizing: "border-box",
    width: "100%",
  },

  hero: {
    paddingTop: "52px",
    paddingBottom: "52px",
    maxWidth: "620px",
  },

  eyebrow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "18px",
  },

  eyebrowDot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    backgroundColor: "#6366f1",
    display: "inline-block",
    flexShrink: 0,
  },

  eyebrowText: {
    fontSize: "11px",
    fontWeight: "700",
    color: "#6366f1",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
  },

  heading: {
    fontSize: "40px",
    fontWeight: "800",
    color: "#111827",
    margin: "0 0 18px 0",
    letterSpacing: "-0.03em",
    lineHeight: "1.12",
  },

  subheading: {
    fontSize: "14px",
    color: "#6b7280",
    lineHeight: "1.75",
    margin: 0,
    fontWeight: "400",
    maxWidth: "520px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "20px",
    width: "100%",
    alignItems: "stretch",
  },

  card: {
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    padding: "32px",
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    cursor: "pointer",
    transition: "border-color 0.15s, box-shadow 0.15s, transform 0.15s",
    boxSizing: "border-box",
    minHeight: "420px",
  },

  cardTopRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "28px",
  },

  iconWrap: {
    width: "52px",
    height: "52px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },

  icon: {
    fontSize: "24px",
  },

  badge: {
    display: "inline-block",
    padding: "4px 12px",
    borderRadius: "4px",
    fontSize: "11px",
    fontWeight: "600",
    letterSpacing: "0.02em",
  },

  cardMiddle: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    marginBottom: "28px",
  },

  cardTitle: {
    fontSize: "17px",
    fontWeight: "700",
    color: "#111827",
    margin: 0,
    letterSpacing: "-0.02em",
  },

  cardDesc: {
    fontSize: "13px",
    color: "#6b7280",
    lineHeight: "1.7",
    margin: 0,
    fontWeight: "400",
  },

  featureList: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px 16px",
    marginBottom: "auto",
  },

  featureItem: {
    display: "flex",
    alignItems: "center",
    gap: "7px",
    fontSize: "12px",
    color: "#9ca3af",
    fontWeight: "500",
  },

  featureDot: {
    width: "4px",
    height: "4px",
    borderRadius: "50%",
    backgroundColor: "#d1d5db",
    flexShrink: 0,
  },

  cardFooter: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginTop: "32px",
  },

  footerDivider: {
    height: "1px",
    backgroundColor: "#f3f4f6",
  },

  cardAction: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },

  actionLabel: {
    fontSize: "13px",
    fontWeight: "700",
  },

  actionArrow: {
    fontSize: "15px",
  },

};